const c = {
  name: "HandsTeamwork",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.7 39.7" style="enable-background:new 0 0 39.7 39.7;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M38.7,19c0.7-0.7,1-1.5,1-2.5s-0.4-1.8-1-2.5c-0.4-0.4-1-0.7-1.5-0.9c0.7-1.3,0.5-3-0.6-4.1
			c-0.7-0.7-1.6-1-2.5-1c0-0.9-0.3-1.8-1-2.5c-0.7-0.7-1.6-1-2.5-1c0,0,0-0.1,0-0.1c0-0.9-0.4-1.8-1-2.5c-1.4-1.3-3.6-1.3-4.9,0
			l-0.1,0.1C24,0.9,22.7,0,21.3,0h-2.1c-1.6,0-2.9,1.1-3.3,2.6c-1.3-0.8-3.1-0.6-4.3,0.5c-0.7,0.7-1,1.6-1,2.5C9.6,5.7,8.7,6,8,6.7
			C7.4,7.3,7,8.2,7,9.2c0,0,0,0,0,0c-0.9,0-1.8,0.3-2.5,1c-1.1,1.1-1.3,2.8-0.6,4.1c-0.6,0.2-1.1,0.4-1.5,0.9
			c-1.4,1.4-1.4,3.6,0,4.9l1.1,1.1L0,24.6L1.4,26l3.7-3.7c0.4,0.1,0.8,0.2,1.2,0.2c0.9,0,1.8-0.4,2.5-1c0.5-0.5,0.9-1.2,1-1.9
			c0.3,0.1,0.5,0.1,0.8,0.1c0.9,0,1.8-0.3,2.5-1c0.5-0.5,0.9-1.2,1-1.9c0.3,0.1,0.5,0.1,0.8,0.1c0.9,0,1.8-0.3,2.5-1
			c0.7-0.7,1-1.5,1-2.5c0-0.3,0-0.5-0.1-0.8c0.7-0.1,1.4-0.4,1.9-1c0.7-0.7,1-1.5,1-2.5c0-0.8-0.3-1.5-0.8-2.2h0.9
			c1.3,0,2.4-0.7,3-1.8l1.7-1.7c0.6-0.6,1.5-0.6,2.1,0c0.3,0.3,0.4,0.7,0.4,1.1s-0.2,0.8-0.4,1.1l-2.8,2.8l1.4,1.4L29.5,7
			C30,6.5,31,6.5,31.6,7c0.6,0.6,0.6,1.5,0,2.1c0,0,0,0,0,0L28.8,12h0v0l1.4,1.4l2.8-2.8c0,0,0,0,0,0c0.6-0.5,1.5-0.5,2.1,0
			c0.6,0.6,0.6,1.5,0,2.1L33.8,14c0,0-0.1,0.1-0.1,0.1l-1.4,1.4l0.7,0.7l0.7,0.7l0.1-0.1l1.4-1.4c0,0,0.1-0.1,0.1-0.1
			c0.6-0.5,1.5-0.4,2,0.1c0.3,0.3,0.4,0.7,0.4,1.1s-0.2,0.8-0.4,1.1L27.9,27c-0.7,0.7-1.5,1.1-2.4,1.3l-7,1.7
			c-0.2,0-0.3,0.1-0.5,0.2l-8.4,8l1.4,1.5l7.9-7.5l3.2,1.6l5.9,5.9l1.4-1.4l-6-6c-0.1-0.1-0.2-0.1-0.3-0.2l-1.5-0.8l4.3-1
			c1.3-0.3,2.4-0.9,3.4-1.9l4.7-4.7l4,4l1.4-1.4l-4-4L38.7,19L38.7,19z M7.3,20.1c-0.6,0.6-1.6,0.6-2.1,0l-1.4-1.4
			c-0.6-0.6-0.6-1.5,0-2.1c0.3-0.3,0.7-0.4,1.1-0.4s0.8,0.1,1.1,0.4L7.4,18C7.9,18.6,7.9,19.5,7.3,20.1L7.3,20.1z M11.6,17.3
			c-0.6,0.6-1.5,0.6-2.1,0l-0.7-0.7c0,0,0,0,0,0l-1.4-1.4c0,0,0,0,0,0l-1.4-1.4c-0.6-0.6-0.6-1.5,0-2.1c0.3-0.3,0.7-0.4,1.1-0.4
			c0.4,0,0.8,0.2,1.1,0.4l3.5,3.5c0.3,0.3,0.4,0.7,0.4,1.1S11.9,17,11.6,17.3z M15.8,14.5c-0.6,0.6-1.5,0.6-2.1,0l-4.2-4.2
			C9.2,9.9,9,9.6,9,9.2c0-0.4,0.2-0.8,0.4-1.1c0.3-0.3,0.7-0.4,1.1-0.4c0.4,0,0.8,0.2,1,0.4l3.5,3.5c0,0,0,0,0,0l0.7,0.7
			C16.4,12.9,16.4,13.9,15.8,14.5z M18.7,10.2c-0.6,0.6-1.5,0.6-2.1,0L13,6.7c-0.6-0.6-0.6-1.5,0-2.1c0.3-0.3,0.7-0.4,1.1-0.4
			s0.8,0.2,1.1,0.4l3.5,3.5c0.3,0.3,0.4,0.7,0.4,1.1S18.9,9.9,18.7,10.2L18.7,10.2z M22.7,3.5c0,0.8-0.7,1.5-1.5,1.5h-2.1
			c-0.8,0-1.5-0.7-1.5-1.5c0-0.8,0.7-1.5,1.5-1.5h2.1C22.1,2,22.7,2.7,22.7,3.5L22.7,3.5z"/>
	</g>
</g>
</svg>
  `
};
export {
  c as HandsTeamwork
};
